export const STRIPE_APPEARANCE = {
	theme: 'night',
	variables: {
		colorPrimary: '#ffd36b',
		colorBackground: 'rgba(255, 255, 255, 0.04)',
		colorText: '#fff7ff',
		colorTextSecondary: '#b894cc',
		colorTextPlaceholder: '#8a6a9e',
		colorDanger: '#ff7a92',
		fontFamily: 'Manrope, system-ui, -apple-system, sans-serif',
		fontSizeBase: '14px',
		spacingUnit: '4px',
		borderRadius: '12px',
		tabIconColor: '#b894cc',
		tabIconSelectedColor: '#ffd36b',
	},
	rules: {
		'.Tab': {
			backgroundColor: 'rgba(255, 255, 255, 0.05)',
			border: '1px solid rgba(255, 255, 255, 0.1)',
			boxShadow: 'none',
			color: '#d8bde4',
			padding: '10px 14px',
			fontSize: '13px',
		},
		'.Tab:hover': {
			border: '1px solid rgba(255, 211, 107, 0.35)',
			color: '#fff7ff',
			backgroundColor: 'rgba(255, 255, 255, 0.07)',
		},
		'.Tab--selected': {
			backgroundColor: 'rgba(255, 77, 242, 0.12)',
			border: '1px solid rgba(255, 77, 242, 0.5)',
			color: '#fff7ff',
			boxShadow: '0 0 24px rgba(255, 77, 242, 0.12)',
		},
		'.TabIcon': {
			width: '20px',
			height: '20px',
		},
		'.TabIcon--selected': {
			fill: '#ffd36b',
		},
		'.TabLabel': {
			fontSize: '13px',
			fontWeight: '600',
		},
		'.Label': {
			color: '#b894cc',
			fontWeight: '700',
			fontSize: '11px',
			letterSpacing: '0.06em',
			textTransform: 'uppercase',
			marginBottom: '6px',
		},
		'.Input': {
			backgroundColor: 'rgba(255, 255, 255, 0.05)',
			border: '1px solid rgba(255, 255, 255, 0.12)',
			boxShadow: 'none',
			color: '#fff7ff',
			padding: '12px 14px',
			fontSize: '14px',
		},
		'.Input:focus': {
			border: '1px solid rgba(255, 211, 107, 0.55)',
			boxShadow: '0 0 0 3px rgba(255, 77, 242, 0.14)',
		},
		'.Input--invalid': {
			border: '1px solid rgba(255, 122, 146, 0.55)',
		},
		'.Block': {
			backgroundColor: 'transparent',
			border: 'none',
			boxShadow: 'none',
			padding: '0',
			marginBottom: '8px',
		},
		'.FormRow': {
			marginBottom: '12px',
		},
		'.FormRow:last-child': {
			marginBottom: '16px',
		},
		'.Link': {
			color: '#ffd36b',
		},
		'.LinkIcon': {
			fill: '#00d924',
		},
	},
};
